exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-view {\n  width: 100%;\n  height: 100%;\n  background-color: rgba(242, 242, 245, 0.69); }\n  .content-view .dropdown {\n    display: \"inline-block\";\n    max-width: 300px;\n    width: 200px;\n    padding-left: 10px;\n    padding-bottom: 10px; }\n  .content-view h3 {\n    margin: 0px;\n    font-size: 12px;\n    color: #979b9f; }\n  .content-view .page-level-chart-wrapper {\n    margin-top: 20px;\n    margin-left: 10px;\n    text-align: center; }\n  .content-view .ant-select-selection {\n    background-color: rgba(242, 242, 245, 0.69); }\n  .content-view .recharts-bar-rectangle {\n    cursor: pointer; }\n  .content-view .download-button {\n    margin-top: 18px;\n    margin-left: 10px; }\n  .content-view .right {\n    float: right; }\n  .content-view .left {\n    float: left; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/AnalyticsMetric/components/ContentView/style.scss
// module id = 987
// module chunks = 0